import React, {useContext, useEffect, useState} from "react";
import {CreateDeliveryContext} from "../../../CreateDeliveryRequest";
import {
    OrderBlockContainer,
    OrderBlockHeader,
    OrderBlockTitle,
    NoBorderTabs
} from "./OrderBlock.styles";
import {CircleMarker} from "../../../../_defaultComponents/CircleMarker/CircleMarker";
import {InputRow} from "../../inputRow/InputRow";
import {Button, Col, Form, Input, Row, Select, Tooltip, Tabs} from "antd";
import {useTranslation} from "react-i18next";
import {DeleteOutlined} from "@ant-design/icons";
import {GeoLocateSelect} from "../../../../_defaultComponents/GeoLocateSelect/GeoLocateSelect";
import {CityFilter} from "../../../../_defaultComponents/FilterComponents";
import CustomerSearchList from "./customerSearchList/CustomerSearchList";
import {formatTurkishNumber, parseTurkishNumber} from "utils/moneyHelper";
import {
    CustomerOrderInformationCol,
    CustomerOrderInformationRow
} from "../../DeliveryRequestForm.styles";

const {TabPane} = Tabs;

export const OrderBlock = ({order, index, isLast = false, ...props}) => {
    const {
        createProduct,
        updateOrder,
        deleteOrder,
        createOrder,
        getError,
        selectedSubCompany,
        paymentTypes,
        paymentTypesLoading,
        isFromCustomerTheme
    } = useContext(CreateDeliveryContext);
    const [receiverCity, setReceiverCity] = useState(null);
    const [displayValue, setDisplayValue] = useState("");
    const [customerInputType, setCustomerInputType] = useState("customerName");
    const {t} = useTranslation(["newRequest"]);

    const handleInputChange = e => {
        const inputValue = e.target.value;

        if (!/^[\d.,]*$/.test(inputValue)) {
            return;
        }
        if (inputValue.length > 0 && /^[.,+\-]/.test(inputValue)) {
            return;
        }

        if (inputValue.length > 1 && inputValue.startsWith("0") && !inputValue.startsWith("0,")) {
            return;
        }

        const formattedValue = formatTurkishNumber(inputValue);
        const numericValue = parseTurkishNumber(formattedValue);

        setDisplayValue(formattedValue);

        updateOrder({
            orderIndex: order?.index,
            order: {price: String(numericValue)}
        });
    };

    const handleCustomerInputChange = value => {
        if (customerInputType === "customerName") {
            updateOrder({
                orderIndex: order?.index,
                order: {receiverName: value, receiptNumber: ""}
            });
        } else {
            updateOrder({
                orderIndex: order?.index,
                order: {receiptNumber: value, receiverName: ""}
            });
        }
    };

    const handleTabChange = activeKey => {
        setCustomerInputType(activeKey);
        // Tab değişiminde validasyon tetiklenmemeli
        if (activeKey === "customerName") {
            updateOrder({
                orderIndex: order?.index,
                order: {receiptNumber: ""},
                skipValidation: true
            });
        } else {
            updateOrder({
                orderIndex: order?.index,
                order: {receiverName: ""},
                skipValidation: true
            });
        }
    };

    const getCustomerInputValue = () => {
        if (customerInputType === "customerName") {
            return order?.receiverName || "";
        } else {
            return order?.receiptNumber || "";
        }
    };

    const getCustomerInputPlaceholder = () => {
        if (customerInputType === "customerName") {
            return "Müşteri adı giriniz";
        } else {
            return "Fiş numarası giriniz";
        }
    };

    useEffect(() => {
        if (order?.receiverCity) {
            setReceiverCity(order.receiverCity);
        } else if (selectedSubCompany?.city) {
            setReceiverCity(selectedSubCompany.city);
        }
    }, [order?.receiverCity, selectedSubCompany]);

    return (
        <OrderBlockContainer isLast={isLast} {...props} isFromCustomerTheme={isFromCustomerTheme}>
            <OrderBlockHeader>
                <Row style={{marginTop: "10px"}}>
                    <CircleMarker color="#AEF001">{index + 2}</CircleMarker>
                    <OrderBlockTitle>
                        {t("newRequest.fields.deliver", {ns: "newRequest"})}
                    </OrderBlockTitle>
                </Row>
                {order.index > 0 && (
                    <Tooltip title={t("newRequest.actions.removeOrder", {ns: "newRequest"})}>
                        <Button
                            onClick={() => deleteOrder({orderIndex: order?.index})}
                            icon={<DeleteOutlined />}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "red"
                            }}
                        />
                    </Tooltip>
                )}
            </OrderBlockHeader>
            <InputRow
                title={t("newRequest.fields.recipient", {ns: "newRequest"})}
                content={
                    <>
                        <Form
                            autoComplete="off"
                            labelCol={{span: 24}}
                            wrapperCol={{span: 24}}
                            scrollToFirstError
                            data-testid="receviverForm"
                            size={isFromCustomerTheme ? "small" : "middle"}
                        >
                            <CustomerOrderInformationRow
                                gutter={16}
                                isFromCustomerTheme={isFromCustomerTheme}
                            >
                                <CustomerOrderInformationCol
                                    xs={24}
                                    sm={isFromCustomerTheme ? 12 : 24}
                                    md={isFromCustomerTheme ? 12 : 24}
                                    lg={isFromCustomerTheme ? 12 : 24}
                                    xl={isFromCustomerTheme ? 12 : 24}
                                >
                                    <Form.Item
                                        validateStatus={
                                            getError(`orders.${order?.index}.receiverName`) ||
                                            getError(`orders.${order?.index}.receiptNumber`)
                                                ? "error"
                                                : "success"
                                        }
                                        help={
                                            getError(`orders.${order?.index}.receiverName`) ||
                                            getError(`orders.${order?.index}.receiptNumber`)
                                        }
                                        style={{
                                            marginBottom: isFromCustomerTheme ? "8px" : "20px"
                                        }}
                                    >
                                        <NoBorderTabs>
                                            <Tabs
                                                activeKey={customerInputType}
                                                onChange={handleTabChange}
                                                size={isFromCustomerTheme ? "small" : "middle"}
                                                style={{marginBottom: "8px"}}
                                                className="no-tab-border"
                                            >
                                                <TabPane tab="Müşteri Adı" key="customerName" />
                                                <TabPane tab="Fiş Numarası" key="receiptNumber" />
                                            </Tabs>
                                        </NoBorderTabs>
                                        {customerInputType === "customerName" ? (
                                            <CustomerSearchList
                                                fieldType="alphanumeric"
                                                placeholder={getCustomerInputPlaceholder()}
                                                name={
                                                    customerInputType === "customerName"
                                                        ? "receiverName"
                                                        : "receiptNumber"
                                                }
                                                data-testid={
                                                    customerInputType === "customerName"
                                                        ? "receiverName"
                                                        : "receiptNumber"
                                                }
                                                value={getCustomerInputValue()}
                                                selectedSubCompanyId={selectedSubCompany?._id}
                                                size={isFromCustomerTheme ? "small" : "middle"}
                                                onCustomerSelect={selectedCustomer => {
                                                    updateOrder({
                                                        orderIndex: order?.index,
                                                        order: {
                                                            ...order,
                                                            receiverPhone:
                                                                selectedCustomer?.receiverPhone,
                                                            receiverName:
                                                                selectedCustomer?.receiverName,
                                                            receiverAddress:
                                                                selectedCustomer?.receiverAddress,
                                                            receiverLocation:
                                                                selectedCustomer?.receiverLocation,
                                                            receiverAddressDetail:
                                                                selectedCustomer?.receiverAddressDetail,
                                                            receiverCity:
                                                                selectedCustomer?.receiverCity ||
                                                                order?.receiverCity ||
                                                                ""
                                                        }
                                                    });
                                                }}
                                                onChange={e =>
                                                    handleCustomerInputChange(e.target.value)
                                                }
                                            />
                                        ) : (
                                            <Input
                                                placeholder={getCustomerInputPlaceholder()}
                                                name={"receiptNumber"}
                                                value={getCustomerInputValue()}
                                                onChange={e =>
                                                    handleCustomerInputChange(e.target.value)
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                </CustomerOrderInformationCol>
                                <Col
                                    xs={24}
                                    sm={isFromCustomerTheme ? 12 : 24}
                                    md={isFromCustomerTheme ? 12 : 24}
                                    lg={isFromCustomerTheme ? 12 : 24}
                                    xl={isFromCustomerTheme ? 12 : 24}
                                    style={{
                                        marginTop: isFromCustomerTheme ? "16px" : "0px",
                                        display: isFromCustomerTheme ? "flex" : "block",
                                        alignItems: isFromCustomerTheme ? "flex-end" : "center"
                                    }}
                                >
                                    <Form.Item
                                        validateStatus={
                                            customerInputType === "customerName" &&
                                            getError(`orders.${order?.index}.receiverPhone`)
                                                ? "error"
                                                : "success"
                                        }
                                        help={
                                            customerInputType === "customerName"
                                                ? getError(`orders.${order?.index}.receiverPhone`)
                                                : null
                                        }
                                        style={{
                                            marginBottom: isFromCustomerTheme ? "8px" : "20px"
                                        }}
                                    >
                                        <h5>
                                            {t("newRequest.fields.recipientPhone", {
                                                ns: "newRequest"
                                            })}
                                        </h5>
                                        <CustomerSearchList
                                            fieldType="phone"
                                            placeholder="0(555)-333-4444"
                                            mask="1(111)-111-1111"
                                            name="receiverPhone"
                                            data-testid="receiverPhone"
                                            value={order?.receiverPhone}
                                            selectedSubCompanyId={selectedSubCompany?._id}
                                            size={isFromCustomerTheme ? "small" : "middle"}
                                            required={customerInputType === "customerName"}
                                            onCustomerSelect={selectedCustomer => {
                                                updateOrder({
                                                    orderIndex: order?.index,
                                                    order: {
                                                        ...order,
                                                        receiverPhone:
                                                            selectedCustomer?.receiverPhone,
                                                        receiverName:
                                                            selectedCustomer?.receiverName,
                                                        receiverAddress:
                                                            selectedCustomer?.receiverAddress,
                                                        receiverLocation:
                                                            selectedCustomer?.receiverLocation,
                                                        receiverAddressDetail:
                                                            selectedCustomer?.receiverAddressDetail,
                                                        receiverCity:
                                                            selectedCustomer?.receiverCity ||
                                                            order?.receiverCity ||
                                                            ""
                                                    }
                                                });
                                            }}
                                            onChange={e =>
                                                updateOrder({
                                                    orderIndex: order?.index,
                                                    order: {receiverPhone: e.target.value}
                                                })
                                            }
                                        />
                                    </Form.Item>
                                </Col>
                            </CustomerOrderInformationRow>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item validateStatus={false ? "error" : "success"}>
                                        <h5>
                                            {t("fields.orderNote", {
                                                ns: "common"
                                            })}
                                        </h5>
                                        <Input.TextArea
                                            rows={isFromCustomerTheme ? 2 : 3}
                                            name={"note"}
                                            data-testid="note"
                                            value={order?.note}
                                            size={isFromCustomerTheme ? "small" : "middle"}
                                            onChange={e =>
                                                updateOrder({
                                                    orderIndex: order?.index,
                                                    order: {note: e.target.value}
                                                })
                                            }
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </>
                }
            />
            <InputRow
                title={t("fields.address", {ns: "common"})}
                content={
                    <>
                        <Form
                            autoComplete="off"
                            labelCol={{span: 24}}
                            wrapperCol={{span: 24}}
                            scrollToFirstError
                            data-testid="receviverForm"
                            size={isFromCustomerTheme ? "small" : "middle"}
                        >
                            <Row gutter={isFromCustomerTheme ? 8 : 16}>
                                <Col span={24}>
                                    <Form.Item
                                        validateStatus={
                                            getError(`orders.${order?.index}.receiverCity`)
                                                ? "error"
                                                : "success"
                                        }
                                        help={getError(`orders.${order?.index}.receiverCity`)}
                                        style={{
                                            marginBottom: isFromCustomerTheme ? "4px" : "16px"
                                        }}
                                    >
                                        <CityFilter
                                            value={receiverCity}
                                            onChange={value => {
                                                setReceiverCity(value);
                                                updateOrder({
                                                    orderIndex: order?.index,
                                                    order: {
                                                        ...order,
                                                        receiverCity: value,
                                                        receiverAddress: "",
                                                        receiverAddressDetail: "",
                                                        receiverLocation: undefined
                                                    }
                                                });
                                            }}
                                            showAllOption={false}
                                            allowClear={true}
                                            ignoreCompanyCheck={true}
                                            size={isFromCustomerTheme ? "small" : "middle"}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        validateStatus={
                                            customerInputType === "customerName" &&
                                            getError(`orders.${order?.index}.receiverAddress`)
                                                ? "error"
                                                : "success"
                                        }
                                        help={
                                            customerInputType === "customerName"
                                                ? getError(`orders.${order?.index}.receiverAddress`)
                                                : null
                                        }
                                        style={{
                                            marginBottom: isFromCustomerTheme ? "4px" : "0px"
                                        }}
                                    >
                                        <h5>
                                            {t("newRequest.fields.recipientAddress", {
                                                ns: "newRequest"
                                            })}
                                        </h5>
                                        <GeoLocateSelect
                                            name="receiverAddress"
                                            data-testid="receiverAddress"
                                            receiverCity={receiverCity}
                                            selectMarginBottom={
                                                getError(`orders.${order?.index}.receiverAddress`)
                                                    ? "0px"
                                                    : isFromCustomerTheme
                                                    ? "6px"
                                                    : "20px"
                                            }
                                            size={isFromCustomerTheme ? "small" : "middle"}
                                            onChange={locationDetail =>
                                                updateOrder({
                                                    orderIndex: order?.index,
                                                    order: {
                                                        ...order,
                                                        receiverAddress:
                                                            locationDetail?.address || "",
                                                        receiverLocation: {
                                                            lon:
                                                                locationDetail.location
                                                                    ?.longitude || 0,
                                                            lat:
                                                                locationDetail.location?.latitude ||
                                                                0
                                                        }
                                                    }
                                                })
                                            }
                                            value={order?.receiverAddress}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span="24">
                                    <Form.Item
                                        validateStatus={false ? "error" : "success"}
                                        style={{
                                            marginBottom: isFromCustomerTheme ? "4px" : "16px"
                                        }}
                                    >
                                        <h5>{"Adres Tarifi"}</h5>
                                        <Input.TextArea
                                            rows={isFromCustomerTheme ? 2 : 3}
                                            name={"receiverAddressDetail"}
                                            data-testid="receiverAddressDetail"
                                            value={order?.receiverAddressDetail}
                                            size={isFromCustomerTheme ? "small" : "middle"}
                                            onChange={e =>
                                                updateOrder({
                                                    orderIndex: order?.index,
                                                    order: {
                                                        ...order,
                                                        receiverAddressDetail: e.target.value
                                                    }
                                                })
                                            }
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </>
                }
            />
            {selectedSubCompany && (
                <>
                    <InputRow
                        title={"Ödeme & Fiyat"}
                        content={
                            <Form
                                autoComplete="off"
                                labelCol={{span: 24}}
                                wrapperCol={{span: 24}}
                                scrollToFirstError
                                data-testid="receviverForm"
                                size={isFromCustomerTheme ? "small" : "middle"}
                            >
                                <Row gutter={16} align="top">
                                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                                        <h5>Ödeme Tipi</h5>
                                        <Form.Item
                                            validateStatus={
                                                getError(`orders.${order?.index}.paymentType`)
                                                    ? "error"
                                                    : "success"
                                            }
                                            help={getError(`orders.${order?.index}.paymentType`)}
                                        >
                                            <Select
                                                style={{width: "100%"}}
                                                value={order?.paymentType}
                                                size={isFromCustomerTheme ? "small" : "middle"}
                                                onChange={value => {
                                                    // Sadece değişen alanı gönder, tüm order'ı değil
                                                    updateOrder({
                                                        orderIndex: order?.index,
                                                        order: {paymentType: value}
                                                    });
                                                }}
                                            >
                                                {paymentTypesLoading ? (
                                                    <Select.Option value={null}>
                                                        {"Yükleniyor..."}
                                                    </Select.Option>
                                                ) : (
                                                    paymentTypes?.codPaymentTypes?.map(
                                                        paymentType => (
                                                            <Select.Option
                                                                key={paymentType}
                                                                value={paymentType}
                                                            >
                                                                {paymentType === "online"
                                                                    ? "Online Ödeme"
                                                                    : paymentType === "creditCard"
                                                                    ? "Kredi Kartı"
                                                                    : paymentType === "cash"
                                                                    ? "Nakit"
                                                                    : paymentType === "mealCard"
                                                                    ? "Yemek Kartı"
                                                                    : paymentType}
                                                            </Select.Option>
                                                        )
                                                    )
                                                )}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                                        <h5>Fiyat Bilgisi</h5>
                                        <Form.Item
                                            validateStatus={
                                                getError(`orders.${order?.index}.price`)
                                                    ? "error"
                                                    : "success"
                                            }
                                            help={getError(`orders.${order?.index}.price`)}
                                        >
                                            <Input
                                                placeholder="Fiyat Bilgisi Giriniz"
                                                style={{width: "100%"}}
                                                value={displayValue}
                                                size={isFromCustomerTheme ? "small" : "middle"}
                                                onChange={handleInputChange}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        }
                    />
                </>
            )}
        </OrderBlockContainer>
    );
};
